export default {"src":"/_next/static/media/zoom-icon.388d66fb.svg","height":24,"width":24};